export default __webpack_public_path__ + "static/media/Rosaria1.2dfa210e.mp3";